<iframe id="inventoryDetailsModalIFrame" width="100%" height="570" frameborder="0"
		[src]="url"></iframe>
